import { GET_COURSES, RESET_COURSES } from "../types";
import * as Sentry from "@sentry/react";

import defaultCourses from "../../config/courses.json";

export default function (courses = defaultCourses, action) {
  switch (action.type) {
    case GET_COURSES:
      return mergeData(courses, action.courses);
    case RESET_COURSES:
      return defaultCourses;
    default:
      return courses;
  }
}

function mergeData(oldCourses, newCourses) {
  return newCourses
    .map((course) => {
      const oldCourse = oldCourses.find((item) => item.id === course.id);
      if (oldCourse) {
        const { description, permalink, img, start } = oldCourse;
        return { ...course, description, permalink, img, start };
      } else {
        // Sentry.captureMessage(`Course not found: ${course.id}`); cause an error if new course is added in the backend
        return null;
      }
    })
    .filter((course) => course !== null);
}
